import {callAPI} from '@/store/utils'; // eslint-disable-line

export default {
  namespaced: true,
  state: {
    patTokensList: [],
    // Owners and admins get every key of the company; everyone else only their own.
    hasOversight: false,
    // Scopes this user may grant: the backend keeps out any whose permission they lack.
    grantableScopes: [],
  },
  mutations: {
    setPatTokensList(state, res) {
      state.patTokensList = res?.result?.data || [];
      state.hasOversight = !!res?.result?.has_oversight;
      state.grantableScopes = res?.result?.grantable_scopes || [];
    },
  },
  actions: {
    async actionGetPatTokensList({rootState, commit}) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/patTokens`,
      );
      commit('setPatTokensList', res);
      return res;
    },
    async actionCreatePatToken({rootState}, params) {
      return await callAPI('POST', `company/${rootState.companyId}/patToken`, {
        company_id: rootState.companyId,
        name: params.name,
        expires_in_days: params.expiresInDays,
        scopes: params.scopes,
      });
    },
    async actionRevokePatToken({rootState}, patTokenId) {
      return await callAPI(
        'DELETE',
        `company/${rootState.companyId}/patToken/${patTokenId}`,
      );
    },
  },
};
